'use strict';
// Select all forms on the page
var forms = document.querySelectorAll('form');
forms.forEach(function(form) {
    var inputs = form.querySelectorAll('input');
    inputs.forEach(function(input) {
        // Create label
        var label = document.createElement('label');
        label.className = 'field-label';
        label.setAttribute('for', input.id);
        // Capitalize input name for label text
        var labelText = input.name ? input.name.charAt(0).toUpperCase() + input.name.slice(1) : 'Field';
        label.textContent = labelText;
        // Set placeholder
        input.placeholder = labelText;
        // Insert label before input
        input.parentElement.insertBefore(label, input);
    });
});

//# sourceMappingURL=js_task_fix_form_DOM.832aed6a.js.map
